import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const PoiSelectPaymentMethodSessionActions = createActionGroup({
  source: 'POI Select Payment Method Component Session',
  events: {
    'Update Session Redirect State Success': emptyProps(),
    'Update Session Redirect State Error': props<{
      error: HttpErrorResponse;
    }>(),
  },
});
